export default __webpack_public_path__ + "static/media/rent.058d0e1b.png";